<template lang="pug">
    .collapsing-checkbox-category(:class='classes')
        .supercategory(v-if='supercategory')
            | {{ supercategory }}
        .category-title(v-if='category')
            | {{ category }}

        transition-group(
            name='slideVertically',
            tag='div',
            v-for='(cb, rowIdx) in checkboxes',
            :key="'transition'+ inputId(categoryIdx, rowIdx)",
        )
            checkbox-row(
                :key="inputId(categoryIdx, rowIdx)",
                v-show="shouldShowRow(cb, rowIdx)",
                :model="model",
                :attributeName="cb.attribute",
                :label="cb.label",
                :tooltipText="cb.tooltip",
                :inputId="inputId(categoryIdx, rowIdx)",
                :bindValueToList="cb.bindValueToList",
            )

        a(
            v-if='checkboxes.length > rowsVisibleWhenCollapsed && numSelected < checkboxes.length',
            @click='toggleExpanded()'
        )
            | {{ currentlyExpanded ? 'Less' : 'More' }}
            span(:class='"rover-icon-in-" + (currentlyExpanded ? "up" : "down")')
</template>

<script>
    import CheckboxRow from './CheckboxRow.vue';

    export default {
        components: { CheckboxRow },
        props: {
            model: {
                type: Object,
                required: true,
            },
            collectionId: {
                type: String,
                required: true,
            },
            category: {
                type: String,
                required: true,
            },
            categoryIdx: {
                type: Number,
                required: true,
            },
            checkboxes: {
                type: Array,
                required: true,
            },
            supercategory: {
                type: String,
                required: false,
            },
            classes: {
                type: String,
                required: false,
            },
            expanded: {
                type: Boolean,
                required: false,
                default: false,
            },
            rowsVisibleWhenCollapsed: {
                type: Number,
                required: false,
                default: 3,
            },
        },
        data() {
            return {
                currentlyExpanded: this.expanded,
            };
        },
        computed: {
            numSelected() {
                return this.checkboxes.reduce((sum, cb) => sum + (this.isSelected(cb) ? 1 : 0), 0);
            },
        },
        methods: {
            reset() {
                this.checkboxes.forEach((cb) => {
                    this.model[cb.attribute] = (cb.bindValueToList > -1) ? [] : false;
                });
            },
            toggleExpanded() {
                this.currentlyExpanded = !this.currentlyExpanded;
            },
            isSelected(checkbox) {
                const modelValue = this.model[checkbox.attribute];
                if (checkbox.bindValueToList > -1) {
                    // checkbox is bound to a list - check for its value in that list
                    return modelValue.includes(checkbox.bindValueToList);
                }
                return !!modelValue;
            },
            shouldShowRow(checkbox, rowIdx) {
                return this.isSelected(checkbox) ||
                    this.currentlyExpanded ||
                    this.shouldShowUnselectedRow(rowIdx);
            },
            shouldShowUnselectedRow(idx) {
                return idx < this.rowsVisibleWhenCollapsed;
            },
            inputId(categoryIdx, rowIdx) {
                return `${this.collectionId}-cat${categoryIdx}-row${rowIdx}`;
            },
        },
    };
</script>

<style lang="scss">
    @import '../../../../css/utilities/mixins';

    .supercategory {
        font-weight: bold;
        text-transform: uppercase;
    }
    .category-title, .supercategory {
        @include responsive-spacing('margin-top', 4);
        @include responsive-spacing('margin-bottom', 2);
        padding-bottom: 2px;
        border-bottom: 1px solid $gray-1;
        font-weight: 500;
    }
    .rover-icon-in-up, .rover-icon-in-down {
        margin-left: 5px;
        vertical-align: middle;
        transform: scale(1, 0.75);
    }
</style>



// WEBPACK FOOTER //
// CheckboxCategory.vue?9f496840